import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Servico } from "@interfaces/service";
import {
  formatarCnae,
  formatarItemLc116
} from "src/app/utils/codigos-servico.util";

@Component({
  selector: "app-service-mobile-card",
  templateUrl: "./service-mobile-card.component.html",
  styleUrls: ["./service-mobile-card.component.scss"]
})
export class ServiceMobileCardComponent {
  @Output() choose = new EventEmitter<void>();
  @Input() service?: Servico;

  readonly formatarCnae = formatarCnae;
  readonly formatarItemLc116 = formatarItemLc116;
}
